import { Component, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@mattlewis92/ng-bootstrap';

import { CropperSettings } from 'ng2-img-cropper';

@Component({
    selector: 'image-crop',
    templateUrl: './image-crop.html',
    styleUrls: ['./image-crop.css'],
    encapsulation: ViewEncapsulation.None
})
export class ImageCropComponent {
    cropperSettings = new CropperSettings();
    constructor(private activeModal:NgbActiveModal) {
        this.cropperSettings.rounded = true;
    }


    selectedImage:{
        image:string;
    } = {
        image: ''
    }
    ok() {
        this.activeModal.close(this.selectedImage.image != '' ? this.selectedImage.image : null);
    }
    cancel() {
        this.activeModal.dismiss();
    };

    onImageSelected(image:File) {
        var reader = new FileReader();
        reader.onload = () => {
            this.selectedImage.image = reader.result;
        } 

        reader.readAsDataURL(image);
    }
}


// WEBPACK FOOTER //
// ./web/static/components/image-crop/image-crop.ts